// extracted by mini-css-extract-plugin
module.exports = {"info":"EventInfo_info__zmMei","title":"EventInfo_title__huGbQ","location":"EventInfo_location__dZBtk","time":"EventInfo_time__9Q75h"};